<template>
  <div
    class="height-100 pt-4">
    <EmptyBlock
      v-if="!loadingMutation && (!notifications || !notifications.length)"
      data-qa="tenders-no-data"
      :text="$t('Tenders.NoData')"/>
    <template v-else>
      <VuetiTable
        :headers="tableHeader"
        item_key="notificationId"
        :items="notifications"
        :loading="loadingMutation"
        :selected.sync="choosed">
        <template
          #[`item.title`]="{ item }">
          <div
            class="pointer width-100 height-100 flex align-top"
            :class="{'bold': !item.isView}"
            @click.prevent.stop="rowClick(item)">
            <TooltipedText
              :line-count="2"
              :value="item.title"/>
          </div>
        </template>
        <template #[`item.dateSend`]="{ item }">
          <span
            class="pointer font-size-12 width-100 height-100 flex align-top"
            @click.prevent.stop="rowClick(item)">{{ item.dateSendStr || '-' }}</span>
        </template>
        <template #loading>
          <div/>
        </template>
      </VuetiTable>
      <InfinityUpdater
        ref="infinity_updater"
        :action="infinityLoad"
        :active="needLoadingItems"
        call-on-mount
        class="mt-3"
        :loading="loadingMutation"/>
      <ModalPreviewSmartNotification
        v-if="modalViewed.visible"
        key="modal-preview-smart-notification"
        :notification="modalViewed.notification"
        @close="modalViewed.visible = false"
        @notification-read="setNotificationAsRead"/>
    </template>
  </div>
</template>
<script>
import EmptyBlock from 'components/common/elements/EmptyBlock.vue'
import InfinityUpdater from 'components/extends/InfinityUpdater.vue'
import VuetiTable from 'components/common/blocks/table/VuetiTable.vue'
import TooltipedText from 'components/common/blocks/tooltiped text/TooltipedText.vue'
import ModalPreviewSmartNotification from 'components/notification/smartTender/ModalPreviewSmartNotification.vue'

import NotificationApi from '@/api/notificationApi'
const notif_api = new NotificationApi()
import { debounce } from 'toolkit/utils/util'

export default {
  name: 'SmarttTenderNotifications',
  data() {
    return {
      notifications: [],
      choosed: [],
      tableHeader: [
        //{text: '', value: 'data-table-select' }, // Пока не делаем
        {
          text: 'Тема',
          value: 'title',
          disableFilter: false,
          sortable: false
        },
        {
          text: 'Дата',
          value: 'dateSend',
          disableFilter: false,
          sortable: false
        },
      ],
      needLoadingItems: true,
      pageProps: {
        page: 0,
        size: 25,
      },
      modalViewed: {
        visible: false,
        notification: null,
        content: null,
      },
    }
  },
  methods: {
    setNotificationAsRead(notificationId) {
      const notification = this.notifications.find(n => n.notificationId === notificationId)
      if (notification !== -1) {
        notification.isView = true
      }
    },
    rowClick: debounce(async function (item) {
      this.modalViewed.notification = item
      this.modalViewed.visible = true
    }, 250),
    infinityLoad: debounce(async function () {
      if (this.needLoadingItems) {
        this.pageProps.page += 1
        await this.getSmartTenderNotifications()
      }
    }, 250),
    async getSmartTenderNotifications() {
      this.loadingMutation = true
      return new Promise((resolve, reject) => {
        notif_api.getNotificationsList(this.pageProps)
          .then((result) => {
            let items = result.data?.notificationsList || []
            if (items?.length < this.pageProps.size) {
              this.needLoadingItems = false
            }

            this.notifications = [...this.notifications, ...items.map(item => {
              const dateSend = item.dateSend === '0001-01-01T00:00:00' ? null : new Date(item.dateSend)
              return {
                ...item,
                dateSend,
                dateSendStr: dateSend ? `${this.$d(dateSend, 'shortDate')} ${this.$d(dateSend, 'longTime')}` : null
              } 
            })]
            return resolve(result)
          })
          .catch((err) => {
            return reject(err)
          })
          .finally(() => {
            this.loadingMutation = false
          })
      })
    },
  },
  computed: {
    loadingMutation: {
      get() {
        return this.loading
      },
      set(value) {
        this.$emit('update:loading', value)
      }
    }
  },
  components: {
    EmptyBlock,
    VuetiTable,
    TooltipedText,
    InfinityUpdater,
    ModalPreviewSmartNotification,
  },
  mounted() {
    //this.getSmartTenderNotifications()
  },
  props: {
    loading: {
      type: Boolean,
    }
  },
}
</script>
<style scoped lang="scss">

</style>
